export var doneOnceJson = {newClientCheck: true};